import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  StorageSelectorFilter,
  StorageSelectorType,
  StorageUtilsService,
} from '../../services/storage-utils.service';
import { FilesListComponent } from '../files-list/files-list.component';

@Component({
  selector: 'storage-modal',
  templateUrl: './storage-modal.component.html',
  styleUrls: ['./storage-modal.component.scss'],
  standalone: false,
})
export class StorageModalComponent {
  selectorType: StorageSelectorType;
  selectorFilter: StorageSelectorFilter;
  enableByURL: boolean = false;

  selectedItemsCount: number = 0;

  @ViewChild(FilesListComponent) filesList: FilesListComponent;

  get title() {
    return this.storageUtilsService.storageTitle(
      this.selectorType,
      this.selectorFilter.name,
    );
  }

  constructor(
    public dialogRef: MatDialogRef<StorageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: StorageModalData,
    private storageUtilsService: StorageUtilsService,
  ) {
    this.selectorType =
      data.selectorType || StorageUtilsService.SELECTOR_TYPES.SINGLE_FILE;
    this.selectorFilter =
      Object.values(StorageUtilsService.SELECTOR_FILTERS).find(
        (filter) => filter.name === data.selectorFilter,
      ) || StorageUtilsService.SELECTOR_FILTERS.ALL;
  }

  selectByUrl() {
    // send blank response to indicate By Url selection
    this.dialogRef.close('url');
  }

  close(files: any[]) {
    this.dialogRef.close(files);
  }

  dismiss() {
    this.dialogRef.close(false);
  }
}

interface StorageModalData {
  selectorType: StorageSelectorType;
  selectorFilter: StorageSelectorFilter['name'];
}
